import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { Col, Row, Stack } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLink } from "@/hooks/useLink";
import Star from "@/assets/Star.svg";
import classes from "./styles.module.scss";
import clsx from "classnames";

export const TeamMemberPageBannerSection = ({ className, item }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <Banner
      className={clsx(className, classes.banner)}
      backlink={{ url: link("team"), label: <DynamicText path={`team.link.back.${locale}`} /> }}
      title={<h1 className="mb-0">{item.name}</h1>}
      image={{ path: "page.team.member.banner.image", src: "/assets/banners/default.png" }}
    >
      <Row>
        <Col xs={12} md={8}>
          <div className="mb-5 pb-5">
            <p className="mb-1">
              <b>Role: </b>
              <span dangerouslySetInnerHTML={{ __html: item[`position_${locale}`] }} />
            </p>
            {item[`speciality_${locale}`] && (
              <p className="mb-1">
                <b>Specialism: </b>
                <span dangerouslySetInnerHTML={{ __html: item[`speciality_${locale}`] }} />
              </p>
            )}
          </div>
        </Col>
      </Row>
    </Banner>
  );
};
